import { useRef, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getPaymentHistory } from "redux/slices/getPaymentHistorySlice";
import {
  stringFormatingToPascal,
  getPolicyType,
  getName,
  getBadgeClassByPolicyStatus,
  getBadgeText,
} from "js/formatting";

import PaymentDetailMultiGridTabs from "../PaymentDetailMultiGridTabs";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import { useTranslation } from "react-i18next";
import Badge from "components/General/Badge";

export default function AnnuityPaymentDetailCard({ data, idx }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  LoadingOverlay.propTypes = undefined;
  const { user } = useSelector((state) => state.user);
  const [primaryOwnerFullName, setPrimaryOwnerFullName] = useState();
  useEffect(() => {
    let primaryOwner = data?.parties?.find(
      (x) => x.person?.type?.toLowerCase() === "primary owner"
    );
    setPrimaryOwnerFullName(getName(primaryOwner?.person));
  }, [user]);
  const [paymentHistories, setPaymentHistories] = useState([]);
  const [scheduledPayments, setScheduledPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let scheduledPaymentList = [];

  let panelRef = useRef(null);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const UUID = uuidv4();
  useEffect(() => {
    dispatch(
      getPaymentHistory([
        {
          contractId: data.contractID,
          policyNumber: data?.contractID,
        },
      ])
    )
      .then((response) => {
        if (response.meta.requestStatus === "fulfilled") {
          setPaymentHistories(response.payload);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error", error.message);
      });
  }, [data]);

  useEffect(() => {
    if (
      data?.draftDate &&
      data?.draftDate !== "" &&
      moment(data.draftDate).format("MM/DD/YYYY") >
        moment().format("MM/DD/YYYY")
    ) {
      let primaryOwner = data?.parties?.find(
        (x) => x.person?.type?.toLowerCase() === "primary owner"
      );
      scheduledPaymentList.push({
        oldPolicy: data?.oldPolicy,
        policyName: stringFormatingToPascal(
          `${data ? `${getPolicyType(data)} - ` : ""} ${getName(
            primaryOwner?.person
          )}`
        ),
        policyNumber: data?.contractID,
        policy_id: data?.contractID,
        amount: data?.modalPremiumAmountTotal ?? 0,
        method: data?.billingType,
        scheduledDate: moment(data.draftDate).format("MM/DD/YYYY"),
        postedDate: moment(data?.nextPaidDueDate).format("MM/DD/YYYY"),
      });
      setScheduledPayments(scheduledPaymentList);
    }
    if (idx === 0) setPanelIsOpen(true);
  }, [idx]);

  return (
    <>
      <EverlakeLoadingOverlay
        isLoading={isLoading}
        loadingText="Please wait while we retrieve your statement... "
      >
        <div className="ui-card mt-4 xl:mt-6">
          <div className="flex flex-row items-start">
            <div className="px-4 pt-3 flex-grow xl:px-6 xl:pt-6">
              <h2 className="mb-0">
                <button
                  ref={panelRef}
                  className="flex items-center group"
                  aria-controls={UUID}
                  aria-expanded={panelIsOpen ? "true" : "false"}
                  aria-label={`Expand or collapse ${primaryOwnerFullName} Policy details`}
                  onClick={() => {
                    setPanelIsOpen((open) => (open = !open));
                  }}
                >
                  <span className="inline-block p-1 rounded-full mr-2 text-ui-blue group-hover:text-white group-hover:bg-ui-blue">
                    <svg
                      className="ui-icon ui-plus w-4 h-4"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-plus"></use>
                    </svg>
                    <svg
                      className="ui-icon ui-minus w-4 h-4"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-minus"></use>
                    </svg>
                  </span>
                  <span className="text-lg font-body font-bold">
                    {primaryOwnerFullName}
                  </span>
                </button>
              </h2>
            </div>
            <div className="px-4 pt-3 xl:px-6 xl:pt-6">
              {data?.status && data?.status !== "" && (
                <Badge
                  mediaSwitch={true}
                  status={getBadgeClassByPolicyStatus(data)}
                  statusText={getBadgeText(data)}
                  srPrefix="Policy"
                />
              )}
            </div>
          </div>
          <hr />
          <div
            id={UUID}
            className={`ui-payment-policy-card ${
              panelIsOpen ? "" : "ui-payment-policy-card-min"
            }`}
          >
            <div className="px-4 xl:px-6">
              <div className="text-xs pl-6 text-theme-text-tertiary">
                {t("CustomerPaymentOverView-annuity-contract-number")}{" "}
                {data.oldPolicy}
              </div>
              <PaymentDetailMultiGridTabs
                paymentHistory={paymentHistories}
                policyId={data?.contractID}
              />
            </div>
          </div>
          <div className="px-4 pt-2 pb-4 text-right">
            <Link to={`/policies/${data.contractID}`} className="text-xs">
              {t("CustomerPaymentOverView-annuity-view-policy-details")}
            </Link>
          </div>
          <hr />
          <div className="text-center text-xs text-theme-text-secondary px-4 pb-6">
            {t("CustomerPaymentOverView-annuity-message")}
          </div>
        </div>
      </EverlakeLoadingOverlay>
    </>
  );
}
